import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { ERROR_MAP } from './error-messages.const';
import { ErrorKey } from './error.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorFacade {
  captureError(error: unknown) {
    console.error(error);
    Sentry.captureException(error);
  }

  getErrorMessage(key: string) {
    if (key in ERROR_MAP) {
      return ERROR_MAP[<ErrorKey>key];
    }

    return ERROR_MAP['UNKNOWN_ERROR'];
  }
}
